import React from 'react';
import { Chip, Typography } from '@mui/material';
import { GridColDef, GridPaginationModel } from '@mui/x-data-grid';
import { FDataGrid } from '../grid';
import { IForecastResultRow } from './bieforecasting.models';

type Props = {
  rows: IForecastResultRow[];
  rowCount: number;
  paginationModel: GridPaginationModel;
  loading?: boolean;
  onPaginationModelChange: (model: GridPaginationModel) => void;
  onRefresh: () => void | Promise<void>;
};

class ForecastResultsGrid extends React.PureComponent<Props> {
  private columns: GridColDef[] = [
    { field: 'variablecode', headerName: 'Variable', width: 145 },
    { field: 'variablename', headerName: 'Name', minWidth: 220, flex: 1 },
    { field: 'productcode', headerName: 'Product', width: 130 },
    { field: 'locationcode', headerName: 'Location', width: 125 },
    { field: 'periodname', headerName: 'Period', width: 135 },
    { field: 'source', headerName: 'Source', width: 175 },
    { field: 'method', headerName: 'Method', width: 175 },
    { field: 'quantity', headerName: 'Quantity', width: 130, type: 'number' },
    { field: 'unitprice', headerName: 'Unit Price', width: 130, type: 'number' },
    { field: 'amount', headerName: 'Amount', width: 150, type: 'number' },
    {
      field: 'confidence', headerName: 'Confidence', width: 120,
      renderCell: (p) => p.value === null || p.value === undefined ? '-' : <Typography fontWeight={800}>{Number(p.value).toFixed(1)}%</Typography>,
    },
    {
      field: 'status', headerName: 'Status', width: 145,
      renderCell: (p) => <Chip size="small" label={p.value || '-'} color={p.value === 'ERROR' ? 'error' : p.value === 'WARNING' ? 'warning' : p.value === 'APPROVED_FACT' ? 'success' : 'info'} />,
    },
    { field: 'warningcount', headerName: 'Warnings', width: 105, type: 'number' },
    { field: 'errorcount', headerName: 'Errors', width: 90, type: 'number' },
    { field: 'remarks', headerName: 'Remarks', minWidth: 220, flex: 1 },
  ];

  render() {
    return (
      <FDataGrid
        title="Forecast Execution Results"
        subtitle="Generated missing-period estimates together with preserved approved facts and execution exceptions."
        rows={this.props.rows}
        columns={this.columns}
        loading={this.props.loading}
        height={560}
        showQuickFilter
        refresh={this.props.onRefresh}
        paginationMode="server"
        rowCount={this.props.rowCount}
        paginationModel={this.props.paginationModel}
        onPaginationModelChange={this.props.onPaginationModelChange}
        pageSizeOptions={[25, 50, 100]}
        getRowId={(row) => row.id || row.rid || row.rix}
        getRowClassName={(p) => p.row.errorcount > 0 ? 'error-row' : p.row.warningcount > 0 ? 'warning-row' : ''}
        sx={{ '& .error-row': { bgcolor: 'error.lighter' }, '& .warning-row': { bgcolor: 'warning.lighter' } }}
      />
    );
  }
}

export default ForecastResultsGrid;
